import { Input } from "@legal-500/legal500-design-system";
import { useForm } from "react-hook-form";
import { BackgroundField, RichTextField, useSyncBlockContent } from "./blockEditorParts";
import type { BlockContentErrors, IframeContent } from "./types";
import styles from "../CMS.module.css";

type IframeEditorProps = {
  value: IframeContent;
  onChange: (value: IframeContent) => void;
  errors?: BlockContentErrors;
};

export function IframeEditor({ value, onChange, errors = {} }: IframeEditorProps) {
  const { control, register, watch } = useForm<IframeContent>({ defaultValues: value });
  useSyncBlockContent(watch, value, onChange);

  return (
    <div className={styles.cardEditorFields}>
      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="iframe-heading">
          Heading (optional)
        </label>
        <Input id="iframe-heading" {...register("heading")} />
      </div>
      <RichTextField control={control} name="intro" id="iframe-intro" label="Intro (optional)" />

      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="iframe-src">
          Source URL
        </label>
        <Input
          id="iframe-src"
          placeholder="https://www.google.com/maps/embed?..."
          error={errors.src}
          {...register("src")}
        />
      </div>

      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor="iframe-title">
          Title (accessibility label)
        </label>
        <Input
          id="iframe-title"
          placeholder="Map showing office location"
          error={errors.title}
          {...register("title")}
        />
      </div>

      <BackgroundField register={register} name="background" stored={value.background} />
    </div>
  );
}
